import {OrganisationType} from "./OrganisationType.js";

export class Organisation {

    /**
     *
     * @param name {string}
     * @param entityType {OrganisationType}
     * @param number {string}
     * @param vatId {string}
     */
    constructor(name, entityType, number, vatId) {
        this._name = name;
        this._entityType = entityType;
        this._number = number;
        this._vatId = vatId;
    }

    /**
     * @returns {string}
     */
    get name() {
        return this._name;
    }

    /**
     * @param value {string}
     */
    set name(value) {
        this._name = value;
    }

    /**
     * @returns {OrganisationType}
     */
    get entityType() {
        return this._entityType;
    }

    /**
     * @param value {OrganisationType}
     */
    set entityType(value) {
        this._entityType = value;
    }

    /**
     * @returns {string}
     */
    get number() {
        return this._number;
    }

    /**
     * @param value {string}
     */
    set number(value) {
        this._number = value;
    }

    /**
     * @returns {string}
     */
    get vatId() {
        return this._vatId;
    }

    /**
     * @param value {string}
     */
    set vatId(value) {
        this._vatId = value;
    }
}